import { RouteRecordRaw } from 'vue-router';
import { AppCoreEnums } from 'src/core/shared/enums';
import { IRouteMeta, ResolveParams } from '../../core/models/routing';

const ROUTE_MAIN = 'main';

const mainRoutes: RouteRecordRaw = {
  path: '/',
  name: ROUTE_MAIN,
  component: () => import('../../layouts/main-layout.vue'),
  meta: <IRouteMeta>{
    resolve: async (resolveParams: ResolveParams) => {
      const { useUiStore } = await import('../../stores/ui/store');
      return Promise.all([useUiStore().fetchMainData(resolveParams)]);
    },
    containerType: AppCoreEnums.ContainerType.NotSpecifiedContainer,
  },
};

export { mainRoutes, ROUTE_MAIN };
